// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3-uO-","header":"MergedInvoice_header__26u_4"};